import UIkit from './UIkit';

const initSlideshows = () => {
  UIkit.util.on('.uk-slideshow', 'beforeitemshow', function (e) {
    const index = parseInt(e.target.dataset.slideIndex) + 1;
    console.log('Showing slide', index.toString().padStart(2, '0'));
  });


  const words = document.querySelectorAll(".word-slider .word");
  let current = 0;

  function showSlide(index) {
    words.forEach((word, i) => {
      word.classList.remove("active");
      if (i === index) {
        word.classList.add("active");

        // Reset animations
        const top = word.querySelector(".half.top");
        const bottom = word.querySelector(".half.bottom");
        top.innerHTML = `<span>${top.textContent}</span>`;
        bottom.innerHTML = `<span>${bottom.textContent}</span>`;
      }
    });
  }

  function autoplay() {
    current = (current + 1) % words.length;
    showSlide(current);
  }

  showSlide(current);
  setInterval(autoplay, 3000);
};

export default initSlideshows;
